<template>
    <component
        v-bind:is="elementTag"
        v-bind:href="helpLink"
        aria-label="help"
        v-bind:target="helpLink ? '_blank' : null"
        no-interact
        class="help-cursor text-primary btn p-0 shadow-none mx-1"
        v-on:click.stop="onClick">
        <pc-bs-icon name="question-circle-fill" />
    </component>
</template>
<script>
    export default {
        props: {
            helpLink: { type: String, required: false, default: null }
        },
        emits: ["click"],
        computed: {
            elementTag() {
                return this.helpLink ? "a" : "button";
            }
        },
        methods: {
            onClick(event) {
                if (!this.helpLink) {
                    this.$emit("click", event);
                }
            }
        }
    };
</script>
<style lang="scss" scoped>
    .help-cursor {
        cursor: help !important;
    }
</style>
